import type { StyleRule } from '@archipro-design/aria';
import {
    labelClassName,
    productTileSlotClassNames,
    pxArrayToRem,
} from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const AriaProductInfoStyle: StyleRule = ({ theme }) => ({
    [`& .${productTileSlotClassNames.product} > div`]: {
        margin: pxArrayToRem([2, 0, 8, 0]),
        fontSize: pxToRem(20),
        lineHeight: pxToRem(22),
        fontWeight: theme.siteVariables.fontWeightRegular,
        letterSpacing: pxToRem(-0.14),
        color: theme.siteVariables.colors.primitive.black,
        textTransform: 'none',
    },

    [`& .${productTileSlotClassNames.professional} > div`]: {
        fontSize: pxToRem(18),
        fontWeight: theme.siteVariables.fontWeightSemilight,
        color: theme.siteVariables.colors.grey['400'],
        textTransform: 'none',
    },

    [`& .${productTileSlotClassNames.price} > div.${labelClassName}`]: {
        ...theme.siteVariables.textStyles.Text.Roman55,
        marginTop: pxToRem(9),
        fontSize: pxToRem(18),
        fontWeight: theme.siteVariables.fontWeightSemilight,
        color: theme.siteVariables.colors.grey['400'],
        textTransform: 'none',
    },
});
